import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, ListGroup } from 'react-bootstrap';

import history from 'browserHistory';
import AdminTop from 'modules/admin/components/AdminTop';
import ListComponent from 'modules/admin/components/ListComponent';
import { logoutSelector } from 'modules/common/LogoutBtn/selectors';
import { getAllBranchRequest } from 'modules/common/LogoutBtn/actions';
import { useModal } from 'modules/shared/hooks';
import YesNoModal from 'modules/shared/YesNoModal';
import { BranchData } from 'entities/Branches/interfaces';
import { deleteBranchRequest } from '../BranchEditing/actions';
import { syncFaceIdRequest } from './actions';

const BranchListContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isShow: isShowYN, openModal: openYN, closeModal: closeYN } = useModal();
  const { branches } = useSelector(logoutSelector);

  const [deletedB, setDeletedB] = useState<number>();

  const onEditBranch = (data: BranchData) => {
    const { id, isDeleted } = data;
    if (isDeleted) {
      setDeletedB(id);
      return openYN();
    }
    history.push(`/globaladmin/branch/${id}`);
  };

  const handleSyncFaceId = (data: BranchData) => {
    const { id, isDeleted } = data;
    if (!isDeleted) {
      dispatch(syncFaceIdRequest(String(id)));
    }
  };

  const confirmDelete = () => {
    if (deletedB) {
      dispatch(deleteBranchRequest(deletedB, false));

      setTimeout(() => dispatch(getAllBranchRequest()), 300);
    }
    closeYN();
  };

  useEffect(() => {
    dispatch(getAllBranchRequest());
  }, []);

  return (
    <Container className="my-4">
      <AdminTop title="Філії та підрозділи:" />
      <ListGroup>
        {branches &&
          branches.map((data) => (
            <ListComponent
              key={data.id}
              onEditBranch={() => onEditBranch(data)}
              handleSyncFaceId={() => handleSyncFaceId(data)}
              {...data}
            />
          ))}
      </ListGroup>
      <YesNoModal isShow={isShowYN} title="Bідновити роботу філії" acceptHandler={confirmDelete} closeModal={closeYN} />
    </Container>
  );
};

export default BranchListContainer;
